import { type NavItemData } from "./AdminSidebar.types";

export const navItems: readonly NavItemData[] = Object.freeze([
  {
    id: "dashboard",
    label: "Dashboard",
    icon: "icon-dashboard",
    iconHover: "icon-dashboard-active",
    href: "/dashboard",
  },
  {
    id: "users",
    label: "Users",
    icon: "icon-users",
    iconHover: "icon-users-active",
    href: "/dashboard/users",
  },
  {
    id: "file-manager",
    label: "File Manager",
    icon: "icon-fileManager",
    iconHover: "icon-fileManager-active",
    href: "/dashboard/file-manager",
  },
  {
    id: "Referrals",
    label: "Referrals",
    icon: "icon-referrals",
    iconHover: "icon-referrals-active",
    href: "/dashboard/referrals",
  },
  {
    id: "sales-and-promotions",
    label: "Sales & Promotion",
    icon: "icon-sales-and-promotion",
    iconHover: "icon-sales-and-promotion-active",
    href: "/dashboard/sales-and-promotions",
  },
  {
    id: "payment-history",
    label: "Payment history",
    icon: "icon-payment-history",
    iconHover: "icon-payment-history-active",
    href: "/dashboard/payment-history",
  },
  {
    id: "payouts",
    label: "Payouts",
    icon: "icon-payout",
    iconHover: "icon-payout-active",
    href: "/dashboard/payouts",
  },
]);
